<template>
  <div>
    <el-select
      v-model="vmodel"
      size="large"
      class="w-100 margin-select"
      filterable
      clearable
      :placeholder="$t('Buscar por nombre o RUT')"
      @change="$emit('update:model', vmodel)"
    >
      <el-option-group
        v-for="(group, i) in users"
        :key="i"
        :label="group.label"
      >
        <el-option
          v-for="(user, ii) in group.options"
          :key="ii"
          :label="user.nombre + ' ' + user.apellido + ' (' + user.rut + ')'"
          :value="user._id"
        >
          <span style="float: left">
            {{ user.nombre + " " + user.apellido }}
          </span>
          <span style="float: right; color: #8492a6; font-size: 13px">
            {{ `${user.rut}` }}
          </span>
        </el-option>
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: String,
      required: true,
    },
    users: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      vmodel: this.model,
    };
  },
};
</script>

<style scoped>
.margin-select {
  margin-bottom: 5px;
}
</style>
